<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: 'e62b1e'
  }
})
Vue.use(VueAxios, axios)
Vue.use(VueSession, {
  persist: true
})

export default {
  name: 'app'
}
</script>
